import React from 'react';
import './FooterSection.css';

const FooterSection: React.FC = () => {
  return (
    <footer className="footer-section">
      <nav className="footer-nav">
        <a href="#product">Product</a>
        <a href="#pricing">Pricing</a>
        <a href="#resources">Resources</a>
        <a href="#contact">Contact Us</a>
      </nav>
      <div className="footer-social">
        {/* Placeholder for social icons */}
        <span>LinkedIn</span>
        <span>Twitter</span>
      </div>
      <p className="copyright">&copy; {new Date().getFullYear()} CheckifAI. All rights reserved.</p>
    </footer>
  );
};

export default FooterSection;
